module.exports = __webpack_public_path__ + "mycenter.png?9b2e5aa143e4cde29825ccdad236dd70";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mycenter.png
// module id = 983
// module chunks = 2